var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 22,
    viewBox: "0 0 15 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V21.8868H14.3958V0H0ZM13.815 21.306H11.7975V15.1295H8.25521V21.306H0.580798V0.580795H13.815V21.306Z",
    fill: "#C45AF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.24406 2.06067V9.10934H6.36717V2.06067H2.24406ZM5.78638 8.52674H2.82486V2.64147H5.78638V8.52674Z",
    fill: "#C45AF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.24406 10.5892V17.636H6.36717V10.5892H2.24406ZM5.78638 17.0552H2.82486V11.17H5.78638V17.0552Z",
    fill: "#C45AF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96573 2.06067V5.8745H12.0888V2.06067H7.96573ZM11.508 5.29371H8.54653V2.64147H11.508V5.29371Z",
    fill: "#C45AF6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96573 7.3562V11.17H12.0888V7.3562H7.96573ZM11.508 10.5874H8.54653V7.937H11.508V10.5874Z",
    fill: "#C45AF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.5c3efb28d00faf5b314fae9d91c4b49a.svg";
export { ForwardRef as ReactComponent };